import React from "react";
import styled from "styled-components";
import { tokens } from "@healthdesk/shared-utils";

const InputWrapper = styled.div`
display:flex;
  border-top: ${(props) =>
    props.top ? `0.55px solid ${tokens.colors.iosSeparator.light}` : "none"};
  padding-top: ${(props) => (props.top ? "10px" : "0")};
  margin-bottom: 10px;
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  
    }
  
  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  
    }
`;

const Input = styled.input`
  flex-grow: 1;
  display: block;
  background: transparent;
  border: 0;
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  border-bottom: 0.55px solid ${tokens.colors.iosSeparator.light};
`;

const Label = styled.label`
  text-align: left;
  display: block;
  font-size: ${({ $large }) => ($large ? "14px" : "12px")};
`;

const SmallInput = ({
  name,
  label,
  type,
  register,
  top,
  placeholder,
  autocomplete,
  defaultValue,
  value,
  onChange,
}) => {
  const normalizeNumber = (value) => {
    var x = value.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return !x[2] ? x[1] : x[1] + " " + x[2] + (x[3] ? " " + x[3] : "");
  };

  return (
    <InputWrapper top={top}>
      <Label htmlFor="name">{label}</Label>
      <Input
        name={name}
        type={type || "text"}
        id={name}
        ref={register}
        onChange={
          onChange
            ? onChange
            : (event) => {
                if (type === "tel") {
                  const { value } = event.target;
                  event.target.value = normalizeNumber(value);
                }
              }
        }
        placeholder={placeholder}
        autocomplete={autocomplete}
        defaultValue={defaultValue}
        value={value}
      />
    </InputWrapper>
  );
};

export default SmallInput;
